export default __webpack_public_path__ + "static/media/IMG_4426.479643ae.jpg";